import React, { useCallback, useEffect, useState } from 'react'
import { ICartOrder } from 'order_components/IOrder'
import GeneratedFrom from 'components/generated_form/GeneratedFrom'
import IInput from 'components/generated_form/IInput'
import { jsDateToString } from 'DatetimeUtils'
import {
  getOrderInfoFormFields,
  getOrderInfoFormFieldsWithDelivery,
} from './OrderInfoFormFields'

const DELIV_TYPE_DELIVERY_ID = 2

const compareDate = (jsDate: Date, pythonDate: string) => {
  let pices = pythonDate.split('.')
  const year = parseInt(pices[2])
  const month = parseInt(pices[1])
  const day = parseInt(pices[0])
  if (jsDate.getFullYear() > year) {
    return 1
  }
  if (jsDate.getFullYear() < year) {
    return -1
  } else {
    if (jsDate.getMonth() + 1 > month) {
      return 1
    }
    if (jsDate.getMonth() + 1 < month) {
      return -1
    } else {
      if (jsDate.getDate() > day) {
        return 1
      }
      if (jsDate.getDate() < day) {
        return -1
      } else {
        return 0
      }
    }
  }
}

interface IOrderInfoFormProps {
  order: ICartOrder
  showExtraPhone?: boolean
  onChange: (parameterKey: string, value: string | number | null) => void
  onChangeDelivType?: (delivTypeId: number) => void
}

const OrderInfoForm: React.FC<IOrderInfoFormProps> = ({
  order,
  showExtraPhone,
  onChange,
  onChangeDelivType,
}) => {
  const [inputs, setInputs] = useState<IInput[]>([])
  const [startTimeMaxValue, setStartTimeMaxValue] = useState('17:00')
  const [endTimeMinValue, setEndTimeMinValue] = useState('8:00')
  const [isDelivery, setIsDelivery] = useState(false)

  useEffect(() => {
    setIsDelivery(order.receive_id === DELIV_TYPE_DELIVERY_ID)
  }, [order])

  useEffect(() => {
    if (isDelivery) {
      setInputs(
        getOrderInfoFormFieldsWithDelivery(
          order,
          !!showExtraPhone,
          startTimeMaxValue,
          endTimeMinValue
        )
      )
    } else {
      setInputs(getOrderInfoFormFields(order, !!showExtraPhone))
    }
  }, [order, showExtraPhone, isDelivery, startTimeMaxValue, endTimeMinValue])

  const handleEntered = useCallback(
    (key: string, value: string | number | null) => {
      if (key === 'desired_start_time' && typeof value === 'string') {
        setEndTimeMinValue(value)
      } else if (key === 'desired_end_time' && typeof value === 'string') {
        setStartTimeMaxValue(value)
      }

      onChange(key, value)

      if (key === 'receive_id' && value) {
        setIsDelivery(value === DELIV_TYPE_DELIVERY_ID)
        onChangeDelivType &&
          onChangeDelivType(typeof value === 'string' ? parseInt(value) || 0 : value)
      }
    },
    [onChange, onChangeDelivType]
  )

  useEffect(() => {
    let now_date = new Date()

    if (order.desired_date) {
      if (compareDate(now_date, order.desired_date) > 0) {
        let tomorrow = new Date()
        tomorrow.setDate(now_date.getDate() + 1)

        const tomorrow_str = jsDateToString(tomorrow)
        handleEntered('desired_date', tomorrow_str)
      }
    }
  }, [order, handleEntered])

  return (
    <>
      <GeneratedFrom inputs={inputs} onEntered={handleEntered} />
    </>
  )
}
export default OrderInfoForm
